<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct && !this.isAmericanCitizen(this.application)"></app-protected-information>
<div class="row mt-3">
  <div class="col-12 col-md-4">
    <h6 class="text-primary">{{ "onboarding.contact-data.mustVerifyMobile" | translate: {Default: "Debes de verificar tu número de celular"} }}</h6>
    <form #formCellPhone="ngForm" (ngSubmit)="formCellPhone.form.valid" novalidate>
      <label>{{ "onboarding.contact-data.phone" | translate: {Default: "No. celular"} }}</label>
      <div class="input-group">

        <div class="dropdown">
          <button
            class="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            (click)="toggleDropdown()"
            aria-expanded="false">
            {{ selectedCountryCode ? '+ ' + selectedCountryCode.dialCode : '+ 1' }}
          </button>
          <ul
            class="dropdown-menu"
            [class.show]="isDropdownOpen"
            aria-labelledby="dropdownMenuButton">
            <li *ngFor="let item of countryCodes" (click)="selectCountry(item)" class="dropdown-item">
              <img [src]="item.flag" class=" m-1 input-group-prepend" height="20" alt="{{item.country}}">
              +{{ item.dialCode }} ({{ item.name }})
            </li>
          </ul>
        </div>

        <input type="tel" class="input-group form-control" [mask]="getDialCodePhoneData(application?.body.phoneCountryCode, configurationService.application)?.mask" name="cellphone" [(ngModel)]="application.body.cellphone" #cellphone="ngModel" [ngClass]="inputFieldCss(cellphone, formCellPhone)" [readOnly]="application.confirmedPhoneNumber || phoneOtpSent" numbers required>

      </div>
    </form>
  </div>
  <div class="col-12 col-md-4 mt-2 center">

    <div class="mt-1 bottom" *ngIf="!application.confirmedPhoneNumber && !phoneOtpSent">
      <button
        *ngIf="!application.confirmedPhoneNumber"
        type="button"
        (click)="(application?.body.cellphone && application?.body.phoneCountryCode) ? displayConfirm = true : null"
        [disabled]="
          !application.body.phoneCountryCode ||
          !application.body.cellphone ||
          application.body.cellphone?.length != getDialCodePhoneData(application?.body.phoneCountryCode, configurationService.application).digits ||
          (application.body.cellphone == registeredCellphone && application.body.phoneCountryCode == registeredCountryCode)"
        class="btn btn-primary">
        <i class="far fa-paper-plane"></i>
        <span>
          {{ "onboarding.contact-data.validatePhone" | translate: {Default: " Clic aquí para verificar tu número"} }}
        </span>
      </button>
    </div>

    <div *ngIf="phoneOtpSent" class="mt-1 bottom">
      <button type="button" (click)="phoneNumberChange(formCellPhone)" class="btn responsive-small btn-outline-primary">
        {{ "onboarding.contact-data.confirmedPhoneChange" | translate: {Default: "¿Quieres cambiar tu número telefónico?"} }}
      </button>
    </div>
    <div *ngIf="application.confirmedPhoneNumber" class="mt-1 bottom text-center">
      <small class="text-sm-center bottom"><span class="text-primary" style="cursor: pointer" (click)="phoneNumberChange(formCellPhone)">{{ "onboarding.contact-data.replaceNumber" | translate: {Default: "Reemplaza el número telefónico existente"} }}</span></small>
    </div>
  </div>
  <div class="col-12 col-md-4 mt-2 center">
    <div *ngIf="phoneOtpSent" class="mt-1 bottom">
      <button type="button" (click)="displayConfirm = true; this.re = 're';" class="btn responsive-small btn-primary">
        {{ "onboarding.contact-data.resend_otp" | translate: {Default: "Reenviar código de verificación"} }}
      </button>
    </div>
  </div>

</div>

<div class="row justify-content-center">
  <div class="col-12 col-md-6 mt-2 center" *ngIf="!application.confirmedPhoneNumber && phoneOtpSent">
    <div *ngIf="!application.confirmedPhoneNumber" class="form-group">
      <label>{{ "onboarding.contact-data.verificationCode" | translate: {Default: "Código de verificación"} }}</label>
      <ng-otp-input (onInputChange)="validateCellPhone($event)" [config]="{length:otpLength, allowNumbersOnly:true}"></ng-otp-input>
    </div>
  </div>

</div>
<hr>
<form #form="ngForm" (ngSubmit)="form.form.valid && onSubmit()" [matchPassword]="['password', 'matchingPassword']" novalidate>
  <div class="row mt-3">
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.contact-data.password" | translate: {Default: "Contraseña"} }}</label>

        <div class="input-group">
          <div class="input-group-append">
            <button
              [ngClass]="showPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
              type="button"
              (click)="this.showPassword = !this.showPassword">
              <i *ngIf="showPassword; else eyeSlash" class="fas fa-eye"></i>
              <ng-template #eyeSlash>
                <i class="fas fa-eye-slash"></i>
              </ng-template>
            </button>
          </div>
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            name="password"
            [(ngModel)]="application.body.password"
            #passwordVal="ngModel"
            (ngModelChange)="passwordValidation()"
            [ngClass]="inputFieldCss(passwordVal, form)"
            (blur)="handleBlur('first')"
            [minLength]="8"
            required>
        </div>

        <div class="text-right">
          <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
          <input class="ml-2" type="checkbox" name="newNip" value="nip" [(ngModel)]="showPassword">
        </div>
      </div>
    </div>
    <div *ngIf="application.body.password" class="col-12 show-small">
      <p *ngIf="!passwordMinLength || !passwordCapsLower || !passwordNumber || !passwordSpecial || passwordSequences || passwordRepetition || !passwordSpaces">{{ "onboarding.contact-data.passwordRequirements" | translate: {Default: "Requisitos de la contraseña:"} }}</p>
      <ul>
        <li class="text-danger" *ngIf="!passwordMinLength">
          <p>{{ "onboarding.contact-data.passwordMinLength" | translate: {Default: "Mínimo ocho, máximo 128 caracteres."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordCapsLower">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordCapsAndLowerCase" | translate: {Default: "Debe incluir por lo menos una letra mayúscula y una minúscula."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordCapsAndLowerCaseExamples" | translate: {Default: "Contraseñas inválidas: PASSWORD, password, password123."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordNumber">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNumber" | translate: {Default: "Debe incluir por lo menos un número."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNumberExamples" | translate: {Default: "Contraseñas inválidas: ApAsswordA, password, AApAssword"} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordSpecial">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordSpecialChar" | translate: {Default: "Debe incluir por lo menos un caracter especial (Que no sea número ni letra)."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordSpecialCharExamples" | translate: {Default: "Contraseñas inválidas: Password123, PASsW0RD, p4sSw0rd"} }}</p>
        </li>
        <li class="text-danger" *ngIf="passwordSequences">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoSequences" | translate: {Default: "No debe incluir 3 o más caracteres en secuencia."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoSequencesExamples" | translate: {Default: "Contraseñas inválidas: 123456, pass123word, passwordABC."} }}</p>
        </li>
        <li class="text-danger" *ngIf="passwordRepetition">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoRepetitions" | translate: {Default: "No debe incluir tres o más caracteres iguales juntos."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoRepetitionsExamples" | translate: {Default: "Contraseñas inválidas: 111111, passs123word, passwooordABC."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordSpaces">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoSpaces" | translate: {Default: "No debe incluir espacios."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoSpacesExamples" | translate: {Default: "Contraseñas inválidas: Pass word123, PASs W0RD, p4sSw0r d"} }}</p>
        </li>
      </ul>
    </div>
    <div class="col-12 col-md-6">
      <div class="form-group">
        <label>{{ "onboarding.contact-data.passwordConfirm" | translate: {Default: "Confirmar contraseña"} }}</label>
        <div class="input-group">
          <div class="input-group-append">
            <button
              [ngClass]="showMatchingPassword ? 'btn rounded-left btn-outline-success' : 'btn rounded-left btn-outline-primary'"
              type="button"
              (click)="this.showMatchingPassword = !this.showMatchingPassword">

              <i *ngIf="showMatchingPassword; else eyeSlash" class="fas fa-eye"></i>
              <ng-template #eyeSlash>
                <i class="fas fa-eye-slash"></i>
              </ng-template>
            </button>
          </div>
          <input
            [type]="showMatchingPassword ? 'text' : 'password'"
            class="form-control"
            name="matchingPassword"
            [(ngModel)]="application.body.matchingPassword"
            #matchingPassword="ngModel"
            [ngClass]="inputFieldCss(matchingPassword, form)"
            (blur)="handleBlur('second')"
            (paste)="false"
            [minLength]="8"
            required>
        </div>
        <div class="text-right">
          <label style="font-size: small">{{ "shared.login.show-password" | translate }}</label>
          <input class="ml-2" type="checkbox" name="newNip2" value="nip" [(ngModel)]="showMatchingPassword">
        </div>
      </div>
    </div>
    <div *ngIf="application.body.password" class="col-12 hidden-small">
      <p *ngIf="!passwordMinLength || !passwordCapsLower || !passwordNumber || !passwordSpecial || passwordSequences || passwordRepetition || !passwordSpaces">{{ "onboarding.contact-data.passwordRequirements" | translate: {Default: "Requisitos de la contraseña:"} }}</p>
      <ul>
        <li class="text-danger" *ngIf="!passwordMinLength">
          <p>{{ "onboarding.contact-data.passwordMinLength" | translate: {Default: "Mínimo ocho, máximo 128 caracteres."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordCapsLower">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordCapsAndLowerCase" | translate: {Default: "Debe incluir por lo menos una letra mayúscula y una minúscula."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordCapsAndLowerCaseExamples" | translate: {Default: "Contraseñas inválidas: PASSWORD, password, password123."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordNumber">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNumber" | translate: {Default: "Debe incluir por lo menos un número."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNumberExamples" | translate: {Default: "Contraseñas inválidas: ApAsswordA, password, AApAssword"} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordSpecial">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordSpecialChar" | translate: {Default: "Debe incluir por lo menos un caracter especial (Que no sea número ni letra)."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordSpecialCharExamples" | translate: {Default: "Contraseñas inválidas: Password123, PASsW0RD, p4sSw0rd"} }}</p>
        </li>
        <li class="text-danger" *ngIf="passwordSequences">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoSequences" | translate: {Default: "No debe incluir 3 o más caracteres en secuencia."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoSequencesExamples" | translate: {Default: "Contraseñas inválidas: 123456, pass123word, passwordABC."} }}</p>
        </li>
        <li class="text-danger" *ngIf="passwordRepetition">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoRepetitions" | translate: {Default: "No debe incluir tres o más caracteres iguales juntos."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoRepetitionsExamples" | translate: {Default: "Contraseñas inválidas: 111111, passs123word, passwooordABC."} }}</p>
        </li>
        <li class="text-danger" *ngIf="!passwordSpaces">
          <p class="p-0 m-0">{{ "onboarding.contact-data.passwordNoSpaces" | translate: {Default: "No debe incluir espacios."} }}</p>
          <p class="small example">{{ "onboarding.contact-data.passwordNoSpacesExamples" | translate: {Default: "Contraseñas inválidas: Pass word123, PASs W0RD, p4sSw0r d"} }}</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="row small text-center">
    <div class="col text-center">
      <p class="small text-primary"><b>{{ "onboarding.contact-data.contactDataScreenFooterTitle1" | translate: {Default: "Información importante para abrir una cuenta de tarjeta: "} }}</b>
        {{ "onboarding.contact-data.contactDataScreenFooterContent1" | translate: {Default: "Para ayudar al Gobierno Federal a luchar contra el financiamiento a las actividades terroristas y de lavado de dinero, el ACTA PATRIOTA solicita a todas las instituciones financieras y a las terceras partes involucradas que obtengan, verifiquen y registren la información que identifica a cada persona que abre una cuenta de tarjeta."} }}</p>
      <p class="small text-primary"><b>{{ "onboarding.contact-data.contactDataScreenFooterTitle2" | translate: {Default: "Lo que esto significa para usted: "} }}</b>
        {{ "onboarding.contact-data.contactDataScreenFooterContent2" | translate: {Default: "Cuando usted abra una cuenta de tarjeta, nosotros te solicitaremos su nombre, dirección, fecha de nacimiento y otra información que nos permita identificarlo. También podemos pedirle una imagen de su licencia de conducir o alguna otra identificación."} }}</p>
    </div>
  </div>

  <div class="col-12">
    <button class="btn btn-secondary float-left" type="button" (click)="onBack()" *ngIf="!this.application.body.altairParentAgentId && this.configurationService.application.brokerEnabled === true && !this.configurationService.application.sendBrokerScreenToEnd">{{ "onboarding.usa-ids.back" | translate: {Default: "Regresar"} }}</button>
    <button type="submit" class="btn btn-primary float-right" [disabled]="(!application.confirmedPhoneNumber && (this.application.body.cellphone != this.registeredCellphone || this.application.body.phoneCountryCode != this.registeredCountryCode)) || !form.valid || !this.passwordSpaces || !this.passwordMinLength || this.passwordRepetition || this.passwordSequences || !this.passwordNumber || !this.passwordSpecial || !this.passwordCapsLower || !this.cameraPerms">{{ "onboarding.contact-data.signIn" | translate: {Default: "Continuar"} }}</button>
  </div>
</form>


<p-dialog header=" " [(visible)]="displayConfirm" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
    <p>{{ "onboarding.contact-data.cellphoneConfirmation" | translate: {Default: "¿Tu número de celular es correcto?"} }}</p>
    <p>{{ application.body.cellphone | mask: getDialCodePhoneData(application.body.phoneCountryCode, configurationService.application)?.mask }}</p>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayConfirm = false">{{ "onboarding.contact-data.no" | translate }}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="generateRecaptcha();displayConfirm = false">{{ "onboarding.contact-data.yes" | translate }}</button>
  </div>
</p-dialog>

<webcam [height]="0" [width]="0" [allowCameraSwitch]="allowCameraSwitch" [trigger]="triggerObservable" (initError)="handleInitError($event)"></webcam>
<!--Display Privacy Modal-->
<p-dialog header=" " [(visible)]="displayPrivacyModal" [modal]="true" [baseZIndex]="10000" [closable]="true" [breakpoints]="{'640px': '75vw'}" [style]="{ 'width': '40vw' }">
  <app-onboarding-privacy-modal (displayEvent)="displayPrivacyModal=$event"></app-onboarding-privacy-modal>
</p-dialog>

<div *ngIf="isDropdownOpen" class="overlay" (click)="isDropdownOpen = false"></div>
